import React, { useState } from 'react';
import AgentEmailInput from '../components/AgentEmailInput';
import SurveyEmbed from '../components/SurveyEmbed';
import { getWebContentSurveyLink } from '../services/api';
import { Alert, AlertTitle, Container, Typography } from '@mui/material';

const WebContentSurvey = () => {
    const [surveyLink, setSurveyLink] = useState('');
    const [error, setError] = useState({ title: '', message: '', severity: '' });

    const handleSurveyLinkChange = async (email) => {
        setError({ title: '', message: '', severity: '' }); // Reset error state
        try {
            const link = await getWebContentSurveyLink(email);
            setSurveyLink(link);
        } catch (error) {
            console.log(error.message);
            setError({ title: error.title, message: error.message, severity: error.severity });
        }
    };

    return (
        <Container maxWidth="md" sx={{ textAlign: 'center', marginTop: '20px' }}>
            {!surveyLink ? (
                <>
                    <Typography variant="h4" color='primary' gutterBottom sx={{ fontWeight: 'bold', mb: 2 }}>
                        Welcome to your Website Content Bio Form!
                    </Typography>
                    <AgentEmailInput onSurveyLinkChange={handleSurveyLinkChange} />
                    {error.message && (
                        <Alert severity={error.severity} sx={{ mt: 2, textAlign: 'left' }}>
                            <AlertTitle>{error.title}</AlertTitle>
                            {error.message}
                        </Alert>
                    )}
                </>
            ) : (
                <SurveyEmbed surveyLink={surveyLink} />
            )}
        </Container>
    );
};

export default WebContentSurvey;